<template>
    <div>
        <div class="m-area">
            <p class="u-title">电子合同签署</p>
            <div v-show="loaded">
                <pdf v-for="index in numPages" :key="index" :src="pdfUrl" :page="index" />
            </div>
            <div class="m-button" v-show="loaded">
                <button type="button" class="u-button" @click="onSign">同意签署</button>
            </div>
        </div>
    </div>
</template>
<script>
    import pdf from 'vue-pdf'
    export default {
        name: 'Index',
        components: {
            pdf
        },
        data () {
            return {
                loaded: false,
                numPages: '',
                pdfUrl: 'http://cbsh5.shuyuewangluo.com/uploads/20221017/3a4b6e5c2c6dbbefd9d6c5adbf9d99c1.pdf'
            }
        },

        created () {
            var docEl = window.document.documentElement
            var width = window.screen.availWidth || window.screen.width
            var rootSize = width / 15
            docEl.style.fontSize = rootSize + 'px'
            document.body.style.background = '#FFFFFF'
            document.body.style.margin = 0
            // 同时设置html和body元素，禁用其横向滚动条
            // docEl.style.overflowX = 'hidden'
            // document.body.style.overflowX = 'hidden'
            this.loadPdf()
        },

        methods: {
            // 上下滚动pdf加载
            loadPdf () {
                // this.$loading.show('加载中...') // loading
                this.pdfUrl = pdf.createLoadingTask(this.pdfUrl)
                this.pdfUrl.promise.then(pdf => {
                    this.$nextTick(() => {
                        this.numPages = pdf.numPages // pdf总页数
                        this.loaded = true
                        // this.$loading.hide()
                    })
                })
            },
            onSign() {

            }
        }
    }
</script>
<style>
    .m-pdf {
        width: 300px;
        height: 500px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/pdf/index.vue